export interface Disposable {
  (): void;
}